import React from 'react';
import { 
    ResponsiveContainer, 
    BarChart, 
    XAxis, 
    YAxis, 
    CartesianGrid, 
    Tooltip, 
    Bar 
} from 'recharts';
import { useTheme, Flex, Text } from '@chakra-ui/react';
import CustomTooltip from '../UI/CustomTooltip'; 
import CustomBarCursor from '../UI/CustomBarCursor';

const ProductDistributionChart = ({ data = [] }) => {
    const theme = useTheme();

    const NEON_COLOR_HEX = theme.colors.secondary 
        ? theme.colors.secondary 
        : (theme.colors.green[400] || '#48BB78'); 
        
    const AXIS_COLOR = theme.colors.gray[400] || '#A0AEC0'; 

    if (!data || data.length === 0) {
        return (
            <Flex justify="center" align="center" h="100%">
                <Text color="gray.500">Nenhum dado de distribuição de produto disponível.</Text>
            </Flex>
        );
    }

    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart 
                data={data} 
                layout="vertical"
                margin={{ top: 20, right: 30, left: 30, bottom: 20 }}
                barCategoryGap="20%"
            >
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 255, 255, 0.1)" />
                
                <XAxis 
                    type="number" 
                    stroke={AXIS_COLOR} 
                    tick={{ fill: AXIS_COLOR, fontSize: 12 }}
                />
                
                <YAxis 
                    dataKey="category" 
                    type="category" 
                    stroke={AXIS_COLOR} 
                    width={150} 
                    tick={{ fill: AXIS_COLOR, fontSize: 12 }}
                    axisLine={false}
                    tickLine={false}
                />
                
                <Tooltip 
                    content={<CustomTooltip format="number" />} 
                    cursor={<CustomBarCursor />}
                    wrapperStyle={{ zIndex: 99 }} 
                /> 
                
                <Bar 
                    dataKey="count" 
                    name="Qtd. Clientes" 
                    radius={[0, 4, 4, 0]} 
                    fill={NEON_COLOR_HEX} 
                    barSize={20} 
                />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default ProductDistributionChart;